'use client';

import { useMemo } from "react";
import Link from "next/link";
import Image from "next/image";

// Assets
import IDot from "@public/png/icon-dot.png"

// Components
import Button from "@src/components/atoms/button";

// Helper
import formatNominal from "@src/helper/formatNominal";
import formatTimeAgo from "@src/helper/formatTime";

const CardProperty = ({
  cover,
  price,
  updated_at,
  property_location,
  title,
  property_category,
  lastItemRef,
  user,
  company,
  bedroom,
  bathroom,
  building_area,
  surface_area,
  unit_price,
  property_type,
  href,
  handleTanyaMarketing,
  special_tags,
  showButtonHubungkan = true,
  showUserName = true,
  showCompany = true,
  showUserInfo = true,
  priority = false,
}) => {
  const KT = typeof +bedroom === "number" && !!+bedroom ? +bedroom : null
  const KM = typeof +bathroom === "number" && !!+bathroom ? +bathroom : null
  const LT = typeof +surface_area === "number" && +surface_area ? +surface_area : null
  const LB = typeof +building_area === "number" && +building_area ? +building_area : null
  const features = [KT && `${KT} KT`, KM && `${KM} KM`, LT && `LT ${LT}`, LB && `LB ${LB}`].filter(Boolean)

  const formattedPropertyCategory = useMemo(() => {
    if (!special_tags?.length) return property_category

    return `${special_tags[0]?.name}`
  }, [special_tags, property_category])

  const handleUnitPrice = useMemo(() => {
    if (!unit_price) return ""

    if (unit_price.includes("/")) {
      return unit_price.replace("Unit", "").trim()
    }

    if (unit_price.includes("Per")) {
      return unit_price.replace("Per", "/").trim()
    }

    return unit_price.trim()
  }, [unit_price])

  return (
    <Link href={href} ref={lastItemRef}>
      <div className="p-1 rounded-[16px] border-[0.5px] border-solid border-[#DEDFDE] bg-white shadow-[0_0_2px_0_rgba(4,7,4,0.08)]">
        <div className="relative w-full aspect-square rounded-[12px] border-[0.5px] border-solid border-[#DEDFDE] mb-[12px]">
          {!!cover?.image?.url && <Image
            src={cover?.image?.url}
            alt={title}
            width={1000}
            height={1000}
            sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, (max-width: 1536px) 33vw, 25vw"
            priority={priority}
            className="w-full h-full object-cover rounded-[8px] "
          />}

          <span className="absolute z-1 top-2 left-2 text-[14px]/[19.6px] font-satoshi-bold text-[#fafafa] px-2 py-0.5 rounded-[8px] bg-[#040704]">{formattedPropertyCategory}</span>
        </div>

        <div className="px-2 pb-2 flex flex-col gap-[2px]">
          <div className="flex items-center justify-between">
            <p className="text-[21px]/[25.2px] tracking-[-0.42px] font-satoshi-bold">Rp{formatNominal(price || 0)}{!!(property_type === "Disewakan" || property_category === "Tanah") && <span className="text-[14px]/[19.6px] font-satoshi text-[#686A68]">{handleUnitPrice}</span>}</p>
            <p className="text-[11px]/[15.4px] tracking-[0.11px] font-satoshi text-[#686A68]">Diperbarui {formatTimeAgo(updated_at)?.replace("yang", "")}</p>
          </div>
          <p className="text-[14px]/[19.6px] tracking-[-0.17px] font-satoshi pb-[1px]">{property_location?.area ?? ""}, {property_location?.city ?? ""}</p>
          {!!features?.length && <div className="flex items-center py-[2px]">
            {features.map((f, i) => {
              return (
                <div key={`${i}-features-${f}`} className="flex items-center">
                  <p className="text-[14px]/[19.6px] font-satoshi text-[#808285]">{f}{f.includes("LT") || f.includes("LB") && <span>m<sup>2</sup></span>}</p>
                  {(i < features.length - 1) && <Image
                    width="auto"
                    height="auto"
                    src={IDot}
                    alt='dot'
                    className='w-2 h-2 object-contain mx-2'
                  />}
                </div>
              )
            })}
          </div>}
          <p className="text-[14px]/[19.6px] font-satoshi text-[#808285] truncate">{title}</p>


          {showUserInfo && <div className="flex items-end justify-between mt-[6px]">
            <div>
              {showUserName && <p className="text-[14px]/[19.6px] font-satoshi truncate">{user?.full_name ?? ""}</p>}
              {showCompany && <p className="text-[14px]/[19.6px] font-satoshi-bold text-[#808285]">CENTURY 21 <span className="font-satoshi-medium text-[11px]/[15.4px] tracking-[0.11px]">{company?.name ?? ""}</span></p>}
            </div>
            {showButtonHubungkan && <Button type="button" className="!py-0 h-[32px]" onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              handleTanyaMarketing()
            }}>Hubungi</Button>}
          </div>}
        </div>
      </div>
    </Link>
  )
}

export default CardProperty
